/* ─────────────────────────────────────────────────────────────────────────────
   PGA Yorkshire — Magnetic Hover on Buttons
   ─────────────────────────────────────────────────────────────────────────────

   Buttons subtly translate toward the cursor while hovered, then spring back
   when the cursor leaves. Works on any element with the [data-magnetic] attr,
   or automatically on all .button elements site-wide.

   Options (via data attributes on the element):
     data-magnetic-strength="0.3"   pull intensity 0–1 (default 0.3)
     data-magnetic-max="10"         max translate in px (default 10)

   You can also add [data-magnetic] to any element to opt-in.

   Automatically disabled for prefers-reduced-motion users.
   ─────────────────────────────────────────────────────────────────────────── */

(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var AUTO_SELECTOR = 'a.button:not(.slider-button), button.button:not(.slider-button), .btn:not(.slider-button)';
  var OPT_IN_ATTR   = 'data-magnetic';
  var DEFAULT_STRENGTH = 0.3;
  var DEFAULT_MAX      = 10;    /* px */
  var EASE_IN   = 'transform 0.12s ease';
  var EASE_OUT  = 'transform 0.55s cubic-bezier(0.23, 1, 0.32, 1)';

  function clamp(val, min, max) {
    return Math.min(Math.max(val, min), max);
  }

  function setup(el) {
    if (el._magInit) return;
    el._magInit = true;

    var strength = parseFloat(el.dataset.magneticStrength) || DEFAULT_STRENGTH;
    var maxPx    = parseFloat(el.dataset.magneticMax)      || DEFAULT_MAX;
    var raf      = null;
    var tx = 0;
    var ty = 0;

    el.addEventListener('mousemove', function (e) {
      var rect = el.getBoundingClientRect();
      /* Offset from centre of the element */
      var dx = e.clientX - (rect.left + rect.width  / 2);
      var dy = e.clientY - (rect.top  + rect.height / 2);

      tx = clamp(dx * strength, -maxPx, maxPx);
      ty = clamp(dy * strength, -maxPx, maxPx);

      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        el.style.transition = EASE_IN;
        el.style.transform  = 'translate(' + tx.toFixed(2) + 'px, ' + ty.toFixed(2) + 'px)';
      });
    });

    el.addEventListener('mouseleave', function () {
      if (raf) { cancelAnimationFrame(raf); raf = null; }
      el.style.transition = EASE_OUT;
      el.style.transform  = 'translate(0px, 0px)';
    });
  }

  function init(root) {
    root = root || document;

    /* Auto-target all .button elements */
    Array.prototype.forEach.call(root.querySelectorAll(AUTO_SELECTOR), setup);

    /* Opt-in elements via [data-magnetic] */
    Array.prototype.forEach.call(root.querySelectorAll('[' + OPT_IN_ATTR + ']'), setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.MagneticHover = { refresh: init };
})();
